import { array, boolean, date, object, string } from 'yup'
import { LocalizedMessage } from '../../shared/i18n/i18n.types'
import { AvailabilitySlot, IssueOption, IssueOptionsResponse, IssueService } from './issue.types'

export const LocalizedMessageSchema = object<LocalizedMessage>().shape({
  en: string().required(),
  fr: string().optional(),
})

export const IssueServiceSchema = object<IssueService>().shape({
  pacesetterCode: string().optional(),
  issueType: string().optional(),
  priority: string().optional(),
  priorityCodeType: string().optional(),
})

export const IssueAvailabilitySchema = object<AvailabilitySlot>().shape({
  startTime: date().required(),
  endTime: date().required(),
})

export const IssueOptionSchema = object<IssueOption>().shape({
  optionCode: string().required(),
  enabled: boolean().required(),
  visible: boolean().required(),
  advisoryMessages: array().of(LocalizedMessageSchema).optional(),
  selectionType: string().optional(),
  // options: array().of(IssueOptionSchema).optional(),
  // testOptions: array().of(IssueOptionSchema).optional(),
  additionalInfo: boolean().optional(),
  requiresTowing: boolean().optional(),
  service: IssueServiceSchema.optional(),
  availability: array().of(IssueAvailabilitySchema).optional(),
})

export const IssueOptionsResponseSchema = object<IssueOptionsResponse>().shape({
  options: array().of(IssueOptionSchema).required()
})
